var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnoccupiedBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Unoccupied Bed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Level-Icon/Active/Bed/Unoccupied-Bed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,3.5 L3.5,6.51055521 L16.9970907,6.51054642 C18.3796695,6.51859127 19.6162449,6.97864796 20.7080914,7.88476127 C21.7326126,8.73500193 22.3081463,10.0130337 22.4737447,11.6960063 L22.5,12.0163035 L22.5,19 L21,19.5 L20.5,17.5189018 L18.9933427,17.5189018 L3.5,17.5254726 L3.5,20 L2,20.5 L1.5,4 L3,3.5 Z M17.026531,8.50634744 L8.49785921,8.50999535 L8.49785921,15.5172977 L18.9938728,15.5106206 L20.5,15.5106207 L20.5,12.0125242 L20.5032213,11.8051114 C20.4899636,11.0497404 20.2004772,10.3510938 19.6193222,9.71428941 C19.0014674,9.03727097 18.1419199,8.62288428 17.026531,8.50634744 L17.026531,8.50634744 Z M7.51106337,8.5104839 L3.5,8.51845922 L3.5,15.5169795 L7.51106337,15.5169795 L7.51106337,8.5104839 Z",
    id: "Combined-Shape",
    stroke: "#579800",
    fill: "#579800"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnoccupiedBed);
export default __webpack_public_path__ + "static/media/UnoccupiedBed.3e6f437e.svg";
export { ForwardRef as ReactComponent };